import 'zone.js';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { downgradeModule, downgradeComponent, setAngularJSGlobal } from '@angular/upgrade/static';
import { AppModule } from './app.module';
// Components to Downgrade
import { DynamicFormsComponent } from './components/dynamic-forms/dynamic-forms.component';
import { GridComponent } from './components/grid/grid.component';
import { LicensesComponent } from './components/licenses/licenses.component';
import { ListComponent } from './components/list/list.component';
import { RulesComponent } from './components/rules/rules.component';
import { LoadingSpinner } from './components/loadingSpinner/loadingSpinner.component';
import { GalleriaComponent } from './components/galleria/galleria.component';
import { InputSwitchComponent } from './components/inputSwitch/inputSwitch.component';
import { DataUsageComponent } from './modules/data-usage/data-usage.module';
import { CellGridSelectorComponent } from './components/cell-grid-selector/cell-grid-selector.component';
import angular from 'angular';
import { EquipmentGridComponent } from './components/equipment-grid/equipment-grid.component';
import { DaypartsComponent } from './components/dayparts/dayparts.component';
import { ScheduleComponent } from './modules/scheduling/components/schedule/schedule.component';
import { ScheduleListComponent } from './modules/scheduling/components/schedule-list/schedule-list.component';
import { ScheduleSelectorComponent } from './modules/scheduling/components/schedule-selector/schedule-selector.component';
import { MessagesComponent } from './components/messages/message.component';
import { MultiSelectComponent } from './components/multiSelect/multiselect.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { AccessListComponent } from './features/access-list/access-list.component';
import { LPRManagementComponent } from './features/lpr-management/lpr-management.component';
import { TopNavComponent } from './components/top-nav/top-nav.component';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { FieldSetComponent } from './components/fieldset/fieldset.component';
setAngularJSGlobal(angular);
const bootstrapFn = (extraProviders) => {
    const platformRef = platformBrowserDynamic(extraProviders);
    return platformRef.bootstrapModule(AppModule);
};
export const downgradedModule = downgradeModule(bootstrapFn);
export const DowngradedDynamicFormsComponent = downgradeComponent({
    component: DynamicFormsComponent,
    downgradedModule
});
export const DowngradedGridComponent = downgradeComponent({
    component: GridComponent,
    downgradedModule
});
export const DowngradedLicensesComponent = downgradeComponent({
    component: LicensesComponent,
    downgradedModule
});
export const DowngradedDaypartsComponent = downgradeComponent({
    component: DaypartsComponent,
    downgradedModule
});
export const DowngradedScheduleComponent = downgradeComponent({
    component: ScheduleComponent,
    downgradedModule
});
export const DowngradedRulesComponent = downgradeComponent({
    component: RulesComponent,
    downgradedModule
});
export const DowngradedScheduleListComponent = downgradeComponent({
    component: ScheduleListComponent,
    downgradedModule
});
export const DowngradedScheduleSelectorComponent = downgradeComponent({
    component: ScheduleSelectorComponent,
    downgradedModule
});
export const DowngradedLoadingSpinnerComponent = downgradeComponent({
    component: LoadingSpinner,
    downgradedModule,
    inputs: ['stopThisSpinner']
});
export const DowngradedListComponent = downgradeComponent({
    component: ListComponent,
    downgradedModule
});
export const DowngradedGalleriaComponent = downgradeComponent({
    component: GalleriaComponent,
    downgradedModule
});
export const DowngradedEquipmentGridComponent = downgradeComponent({
    component: EquipmentGridComponent,
    downgradedModule
});
export const DowngradedInputSwitchComponent = downgradeComponent({
    component: InputSwitchComponent,
    downgradedModule
});
export const DowngradedDataUsageComponent = downgradeComponent({
    component: DataUsageComponent,
    downgradedModule
});
export const DowngradedCellGridSelectorComponent = downgradeComponent({
    component: CellGridSelectorComponent,
    downgradedModule
});
export const DowngradedUserAccessListsComponent = downgradeComponent({
    component: AccessListComponent,
    downgradedModule
});
export const DowngradedFieldSetComponent = downgradeComponent({
    component: FieldSetComponent,
    downgradedModule
});
export const DowngradedMessageComponent = downgradeComponent({
    component: MessagesComponent,
    downgradedModule
});
export const DowngradedMultiSelectComponent = downgradeComponent({
    component: MultiSelectComponent,
    downgradedModule
});
export const DowngradedDropdownComponent = downgradeComponent({
    component: DropdownComponent,
    downgradedModule
});
export const DowngradedLprManagementComponent = downgradeComponent({
    component: LPRManagementComponent,
    downgradedModule
});
export const DowngradedNgTopnavComponent = downgradeComponent({
    component: TopNavComponent,
    downgradedModule
});
export const DowngradedSideNavComponent = downgradeComponent({
    component: SideNavComponent,
    downgradedModule
});
angular.module(downgradedModule)
    .directive('dynamicForms', DowngradedDynamicFormsComponent)
    .directive('grid', DowngradedGridComponent)
    .directive('licenses', DowngradedLicensesComponent)
    .directive('t20List', DowngradedListComponent)
    .directive('dayparts', DowngradedDaypartsComponent)
    .directive('schedule', DowngradedScheduleComponent)
    .directive('scheduleList', DowngradedScheduleListComponent)
    .directive('scheduleSelector', DowngradedScheduleSelectorComponent)
    .directive('loadingSpinner', DowngradedLoadingSpinnerComponent)
    .directive('galleria', DowngradedGalleriaComponent)
    .directive('equipmentGrid', DowngradedEquipmentGridComponent)
    .directive('rules', DowngradedRulesComponent)
    .directive('inputSwitch', DowngradedInputSwitchComponent)
    .directive('datausage', DowngradedDataUsageComponent)
    .directive('cellGridSelector', DowngradedCellGridSelectorComponent)
    .directive('userAccessLists', DowngradedUserAccessListsComponent)
    .directive('message', DowngradedMessageComponent)
    .directive('multiSelect', DowngradedMultiSelectComponent)
    .directive('dropdown', DowngradedDropdownComponent)
    .directive('lprManagement', DowngradedLprManagementComponent)
    // aliases to allow AngularJS templates to use Angular component selector
    .directive('topnav', DowngradedNgTopnavComponent)
    .directive('rvSideNav', DowngradedSideNavComponent)
    .directive('fieldSet', DowngradedFieldSetComponent);
